import { Functionaries } from "../../../listsSettings/functionaries";

export const allItems: string = `/${Functionaries.InternalName}/_lists/${Functionaries.Lists.Legislatures.InternalName}/_pages/all_items`;
export const newForm: string = `/${Functionaries.InternalName}/_lists/${Functionaries.Lists.Legislatures.InternalName}/_pages/new`;
export const dispForm: string = `/${Functionaries.InternalName}/_lists/${Functionaries.Lists.Legislatures.InternalName}/_pages/disp`;
export const editForm: string = `/${Functionaries.InternalName}/_lists/${Functionaries.Lists.Legislatures.InternalName}/_pages/edit`;
